export const SET_UNREAD = 'SET_UNREAD';
export const SET_CURRENT_CATEGORY = 'SET_CURRENT_CATEGORY';
export const SET_CURRENT_FILTER = 'SET_CURRENT_FILTER';
export const RESET_UNREAD_COUNTER = 'RESET_UNREAD_COUNTER';
export const GET_USER_NOTIFICATIONS = 'GET_USER_NOTIFICATIONS';
export const GET_USER_NOTIFICATIONS_SUCCESS = 'GET_USER_NOTIFICATIONS_SUCCESS';
export const GET_USER_NOTIFICATIONS_ERROR = 'GET_USER_NOTIFICATIONS_ERROR';
export const PUT_FAVOURITE_USER_NOTIFICATION = 'PUT_FAVOURITE_USER_NOTIFICATION';
export const PUT_FAVOURITE_USER_NOTIFICATION_SUCCESS = 'PUT_FAVOURITE_USER_NOTIFICATION_SUCCESS';
export const PUT_FAVOURITE_USER_NOTIFICATION_ERROR = 'PUT_FAVOURITE_USER_NOTIFICATION_ERROR';
export const INCREASE_PAGE = 'INCREASE_PAGE';
export const DISABLE_LOAD_MORE = 'DISABLE_LOAD_MORE';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const SET_IS_OPEN = 'SET_IS_OPEN';
export const PUSH_NOTIFICATION = 'PUSH_NOTIFICATION';

export const setUnreadAction = payload => ({
  type: SET_UNREAD,
  payload,
});

export const setCurrentCategoryAction = id => ({
  type: SET_CURRENT_CATEGORY,
  payload: {
    id,
  },
});

export const setCurrentFilterAction = id => ({
  type: SET_CURRENT_FILTER,
  payload: {
    id,
  },
});

export const resetUnreadCounterAction = () => ({
  type: RESET_UNREAD_COUNTER,
});

export const getUserNotificationsAction = ({ page, filter, category, limit }) => ({
  type: GET_USER_NOTIFICATIONS,
  payload: {
    page,
    filter,
    category,
    limit,
  },
});

export const putFavouriteUserNotificationAction = ({ id, isFavourite }) => ({
  type: PUT_FAVOURITE_USER_NOTIFICATION,
  payload: {
    id,
    isFavourite,
  },
});

export const increasePage = page => ({
  type: INCREASE_PAGE,
  payload: {
    page,
  },
});

export const disableLoadMore = () => ({
  type: DISABLE_LOAD_MORE,
});

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS,
});

export const setIsOpen = value => ({
  type: SET_IS_OPEN,
  payload: {
    value,
  },
});

export const pushNotification = data => ({
  type: PUSH_NOTIFICATION,
  payload: {
    data,
  },
});
